import { render, staticRenderFns } from "./SampleReceive.vue?vue&type=template&id=4344ac94&scoped=true&"
import script from "./SampleReceive.vue?vue&type=script&lang=js&"
export * from "./SampleReceive.vue?vue&type=script&lang=js&"
import style0 from "./SampleReceive.vue?vue&type=style&index=0&id=4344ac94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4344ac94",
  null
  
)

export default component.exports